import LabBookingNavBar from "./LabBookingNavBar";

const LabBookingLayout = ({ children }) => {
  return (
    <div className="min-h-screen bg-gradient-to-b from-white to-[#EAF6F1]">
      <LabBookingNavBar />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-12 py-8">
        {children}
      </div>
    </div>
  );
};

export default LabBookingLayout;
